import { environment } from "./environments/environment";

/** Employer app deprecata: reindirizza al JBox in base all'environment. */
const jboxBase = environment.jboxUrl.replace(/\/$/, "");
window.location.replace(jboxBase);
